import { ContentPropertyData, CreativeTypes, TextStyle } from '@bynder-studio/render-core';
import ProxyServerConnector from '../web/src/services/connectors/ProxyServerConnector';

export interface Component {
    id: number;
    name: string;
    description: string;
    collectionId: number;
    type: CreativeTypes;
    created: string;
    thumbnailUrl?: string;
    elements: any[];
    textStyles: TextStyle[];
    contentProperties: ContentPropertyData[];
}

export type PartialComponent = Omit<Component, 'elements' | 'textStyles' | 'contentProperties'>;

export interface AddComponentRequest {
    name: string;
    description: string;
    collectionId: number;
    type: CreativeTypes;
    elements: any[];
    textStyles: TextStyle[];
    contentProperties: ContentPropertyData[];
}

interface GetComponentsParams {
    size: number;
    page: number;
    search?: string;
    sort?: [string, string];
    types?: CreativeTypes[];
    collectionId?: number;
}

export interface GetComponentsResponse {
    content: PartialComponent[];
    pageable: {
        pageNumber: number;
        pageSize: number;
        sort: {
            empty: boolean;
            sorted: boolean;
            unsorted: boolean;
        };
        offset: number;
        paged: boolean;
        unpaged: boolean;
    };
    last: boolean;
    totalElements: number;
    totalPages: number;
    first: boolean;
    size: number;
    number: number;
    sort: {
        empty: boolean;
        sorted: boolean;
        unsorted: boolean;
    };
    numberOfElements: number;
    empty: boolean;
}

class ComponentService extends ProxyServerConnector {
    gateway: ProxyServerConnector;

    constructor(path = '/template-presets') {
        super(path);
        this.gateway = new ProxyServerConnector(path, GATEWAY_PREFIX);
    }

    addComponent(component: AddComponentRequest) {
        return this.gateway.post('', component);
    }

    getComponents({ size, page, search, sort, types, collectionId }: GetComponentsParams) {
        const params = new URLSearchParams({
            size: size.toString(),
            page: page.toString(),
        });

        if (search) {
            params.append('search', search);
        }

        if (sort?.length) {
            params.append('sort', sort.join(','));
        }

        if (types?.length) {
            params.append('types', types.join(','));
        }

        if (collectionId !== undefined) {
            params.append('collectionId', collectionId.toString());
        }

        return this.gateway.get<GetComponentsResponse>(`?${params.toString()}`);
    }

    getComponentById(id: string) {
        return this.gateway.get<Component>(`/${id}`);
    }
}

export default new ComponentService();
